module.exports = { str: "7.6.0" };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/version.js
// module id = 269
// module chunks = 0